import React from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../utils/dom';

const StructuredData = ({ metaInfo, product, soldOut, price = {}, currency, image }) => {
	const jsonData = {
		'@context': 'http://schema.org',
		'@type': 'Product',
		url: metaInfo.linkCanonical,
		name: metaInfo.title,
		brand: {
			'@type': 'Brand',
			name: product.brandName,
		},
		sku: product.sku,
		description: metaInfo.metaDescription,
		image,
		itemCondition: 'https://schema.org/NewCondition',
		offers: {
			'@type': 'Offer',
			availability: (soldOut ? 'https://schema.org/OutOfStock' : 'http://schema.org/InStock'),
			price: price.priceAsNumber,
			priceCurrency: currency,
			url: metaInfo.linkCanonical,
			seller: {
				'@type': 'Organization',
				name: 'Manasi7',
			},
		},
	};

	return (
		<script type="application/ld+json" dangerouslySetInnerHTML={{ __html: purifier(JSON.stringify(jsonData), { ALLOWED_TAGS: [] }) }} />
	);
};

export default hot(module)(StructuredData);
